import { useDialogStore } from '../store';

export const DialogContainer = () => {
  const { dialogs, closeDialog } = useDialogStore();

  return (
    <>
      {dialogs.map((dialog) => {
        const DialogComponent = dialog.component;
        return (
          <div key={dialog.id} style={{ zIndex: dialog.zIndex }}>
            <DialogComponent
              {...dialog.props}
              isOpen={dialog.isOpen}
              onClose={() => closeDialog(dialog.id)}
            />
          </div>
        );
      })}
    </>
  );
};